import { PaginationTypes } from 'types/sharedResponse'

export const GET_COMMENTS = 'GET_COMMENTS'
export const GET_COMMENTS_PENDING = 'GET_COMMENTS_PENDING'
export const GET_COMMENTS_FULFILLED = 'GET_COMMENTS_FULFILLED'
export const GET_COMMENTS_REJECTED = 'GET_COMMENTS_REJECTED'
export const CLEAR_GET_COMMENTS = 'CLEAR_GET_COMMENTS'

type CommentCandidateData = {
  current_role: string
  id: number
  name_ar: string
  name_en: string
  name_i18n: string
}

export type CommentData = {
  id: number
  text: string
  candidate: CommentCandidateData
  commenter_id: number
  organization_id: number
  job_title: string
  created_at: string
  updated_at: string
}

export type GetCommentsRequest = {
  page: number
  per_page: number
}

export type GetCommentsResponse = {
  data: {
    comments: CommentData[]
  }
  pagination: PaginationTypes
  success: boolean
  statusCode: number
}
